import * as React from "react";
import { Box, Button, useTheme, useMediaQuery } from "@mui/material";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import useDebounce from "../../hooks/useDebounce";
import { StyledTextField } from "../global";

interface FinancesTableToolbarProps {
  onSearch: (query?: string) => void;
}

const FinancesTableToolbar = ({ onSearch }: FinancesTableToolbarProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [query, setQuery] = React.useState<string | undefined>(undefined);
  const debounceQuery = useDebounce(query, 500);

  React.useEffect(() => {
    onSearch(debounceQuery);
  }, [debounceQuery, onSearch]);

  return (
    <GridToolbarContainer
      sx={{
        padding: { xs: "12px 16px", sm: "16px 20px" },
        marginBottom: 0,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: { xs: 1.5, sm: 2 },
      }}
    >
      <Box flex={1} sx={{ display: "flex", alignItems: "center", gap: 1, width: { xs: "100%", sm: "auto" } }}>
        <StyledTextField
          margin="dense"
          label="Enter to search.."
          value={query || ""}
          onChange={(e) => setQuery(e.target.value)}
          sx={{ 
            minWidth: { xs: "100%", sm: 250 },
            flex: { xs: 1, sm: "none" },
          }}
        />
        {!!query && (
          <Button 
            variant="text" 
            sx={{ 
              mt: { xs: 0, sm: 1 },
              ml: { xs: 0, sm: 1 },
              whiteSpace: "nowrap",
            }} 
            onClick={() => setQuery("")}
          >
            Reset
          </Button>
        )}
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "auto" }, justifyContent: { xs: "flex-start", sm: "flex-end" } }}>
        <GridToolbarExport
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{ allColumns: true, fileName: "Finances" }}
        />
      </Box>
    </GridToolbarContainer>
  );
};

export default FinancesTableToolbar;

